import { Checkbox, DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOfficeStateLocalWithholdingsReport extends Layout {
    checkboxIncludeSettlement: Checkbox;
    checkboxReverseVoids: Checkbox;
    excludabletextboxLocation: ExcludableTextbox;
    excludabletextboxPayee: ExcludableTextbox;
    sourceStateLocalWithholdingsReports: DataSource;
    switchReportType: Switch;
    textboxDateRange: Textbox;
    textboxReportBy: Textbox;
}
